import type { LiveConfig } from "../lib/live-config";

// Dogfood build-identity footer (GW-PHONE-SMOKE-STATUS-PANEL). Lets Nick confirm on a phone
// that the LIVE deploy is the build he expects and that its public config is complete -
// key NAMES and presence only, never values. Pure render over the already-parsed config:
// no network calls, no mutation controls, no analytics value display.
//
// Marketing CalVer is shown; full stamp (+sha) stays in the title for support compare.

const REQUIRED_KEYS: ReadonlyArray<keyof LiveConfig> = [
  "supabaseUrl",
  "supabasePublishableKey",
  "accountId",
  "accountName",
];

function marketingFromStamp(appVersion: string): string {
  const trimmed = appVersion.trim();
  if (trimmed.length === 0) return "";
  const plus = trimmed.indexOf("+");
  return plus === -1 ? trimmed : trimmed.slice(0, plus);
}

/** Names-only presence line, e.g. "supabaseUrl ok - ... - analytics key present". */
export function describeConfigPresence(config: LiveConfig): string {
  const required = REQUIRED_KEYS.map((key) => {
    const value = config[key];
    const present = typeof value === "string" && value.length > 0;
    return `${key} ${present ? "ok" : "MISSING"}`;
  });
  const analytics = `analytics key ${config.posthogKey ? "present" : "absent"}`;
  return [...required, analytics].join(" - ");
}

export function BuildIdentity({ appVersion, config }: { appVersion: string; config: LiveConfig }) {
  const marketing = marketingFromStamp(appVersion);
  const version = marketing.length > 0 ? `v${marketing}` : "version unavailable";
  const full = appVersion.trim();
  return (
    <footer className="buildline" aria-label="Build identity" title={full.length > 0 ? full : undefined}>
      <span className="buildline__version">{version}</span>
      <span className="buildline__config">{describeConfigPresence(config)}</span>
    </footer>
  );
}
